module.exports = __webpack_public_path__ + "static/img/bannerModel.1372903b.png";